import { Suspense, lazy } from 'react';
import { Navigate } from 'react-router-dom';

import SidebarLayout from 'src/layouts/SidebarLayout';
import BaseLayout from 'src/layouts/BaseLayout';
import SuspenseLoader from 'src/components/SuspenseLoader';
import About from './content/applications/views/about/About';
import TermsOfUse from './content/applications/views/Terms/TermsOfUse';
import PrivacyPolicy from './content/applications/views/privacy/PrivacyPolicy';

const Loader = (Component) => (props) => (
  <Suspense fallback={<SuspenseLoader />}>
    <Component {...props} />
  </Suspense>
);

const GoogleAuthSuccess = Loader(lazy(() => import('src/content/applications/Sign in/GoogleAuthSuccess')));

const Signin = Loader(lazy(() => import('src/content/applications/Sign in/SignIn')));
const Signup = Loader(lazy(() => import('src/content/applications/signup/Signup')));
const ForgotPassword = Loader(lazy(() => import('src/content/applications/Sign in/forgotPassword/ForgotPassword')));
const ResetPassword = Loader(lazy(() => import('src/content/applications/Sign in/forgotPassword/ResetPassword')));
const GoogleCallback = Loader(lazy(() => import('src/content/applications/auth/GoogleCallback')));
const GoogleSuccess = Loader(lazy(() => import('src/content/applications/auth/GoogleSuccess')));
const Company = Loader(lazy(() => import('src/content/applications/company/index')));
const Claims = Loader(lazy(() => import('src/content/applications/claims/index')));
const Favourites = Loader(lazy(() => import('src/content/applications/favourites/index')));
const Tasks = Loader(lazy(() => import('src/content/dashboards/Tasks')));
const CompanyList = Loader(lazy(() => import('src/content/dashboards/CompanyList')));
const Messenger = Loader(lazy(() => import('src/content/applications/Messenger')));
const Transactions = Loader(lazy(() => import('src/content/applications/Transactions')));
const Map = Loader(lazy(() => import('src/content/applications/map')));
const UserProfile = Loader(lazy(() => import('src/content/applications/Users/profile')));
const UserSettings = Loader(lazy(() => import('src/content/applications/Users/settings')));
const Buttons = Loader(lazy(() => import('src/content/pages/Components/Buttons')));
const Modals = Loader(lazy(() => import('src/content/pages/Components/Modals')));
const Accordions = Loader(lazy(() => import('src/content/pages/Components/Accordions')));
const Tabs = Loader(lazy(() => import('src/content/pages/Components/Tabs')));
const Badges = Loader(lazy(() => import('src/content/pages/Components/Badges')));
const Tooltips = Loader(lazy(() => import('src/content/pages/Components/Tooltips')));
const Avatars = Loader(lazy(() => import('src/content/pages/Components/Avatars')));
const Cards = Loader(lazy(() => import('src/content/pages/Components/Cards')));
const Forms = Loader(lazy(() => import('src/content/pages/Components/Forms')));
const Status404 = Loader(lazy(() => import('src/content/pages/Status/Status404')));
const Status500 = Loader(lazy(() => import('src/content/pages/Status/Status500')));
const StatusComingSoon = Loader(lazy(() => import('src/content/pages/Status/ComingSoon')));
const StatusMaintenance = Loader(lazy(() => import('src/content/pages/Status/Maintenance')));

const routes = [
  {
    path: '',
    element: <BaseLayout />,
    children: [
      { path: 'auth/google/success', element: <GoogleAuthSuccess /> },

      { path: '/', element: <Signin /> },
      { path: 'signin', element: <Signin /> },
      { path: 'Signup', element: <Signup /> },
      { path: 'ForgotPassword', element: <ForgotPassword /> },
      { path: 'ResetPassword', element: <ResetPassword /> },
      { path: 'about', element: <About /> },
      { path: 'terms', element: <TermsOfUse /> },
      { path: 'privacy', element: <PrivacyPolicy /> },
      {
        path: 'status',
        children: [
          { path: '', element: <Navigate to="404" replace /> },
          { path: '404', element: <Status404 /> },
          { path: '500', element: <Status500 /> },
          { path: 'maintenance', element: <StatusMaintenance /> },
          { path: 'coming-soon', element: <StatusComingSoon /> }
        ]
      },
      { path: '*', element: <Status404 /> }
    ]
  },
  {
    path: 'dashboards',
    element: <SidebarLayout />,
    children: [
      { path: '', element: <Navigate to="home" replace /> },
      { path: 'home', element: <Tasks /> },
      { path: 'map', element: <Map /> },
      { path: 'messenger', element: <Messenger /> },
      { path: 'company/:id', element: <Company /> },
      { path: 'companies/country/:country', element: <CompanyList /> },
      { path: 'companies/business-area/:businessAreaId', element: <CompanyList /> },
      { path: 'claims', element: <Claims /> },
      { path: 'Favourites', element: <Favourites /> }
    ]
  },
  {
    path: 'profil',
    element: <SidebarLayout />,
    children: [{ path: '', element: <UserSettings /> }]
  },
  {
    path: 'management',
    element: <SidebarLayout />,
    children: [{ path: '', element: <Navigate to="transactions" replace /> }]
  },
  {
    path: '/components',
    element: <SidebarLayout />,
    children: [
      { path: '', element: <Navigate to="buttons" replace /> },
      { path: 'buttons', element: <Buttons /> },
      { path: 'modals', element: <Modals /> },
      { path: 'accordions', element: <Accordions /> },
      { path: 'tabs', element: <Tabs /> },
      { path: 'badges', element: <Badges /> },
      { path: 'tooltips', element: <Tooltips /> },
      { path: 'avatars', element: <Avatars /> },
      { path: 'cards', element: <Cards /> },
      { path: 'forms', element: <Forms /> }
    ]
  }
];

export default routes;